import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
import { Label } from './label.js';
import { Switch } from './switch.js';
/**
 * Строка «тумблер + подпись + объяснение» — один флаг, который сохраняется
 * сразу по щелчку (без кнопки «Сохранить»).
 *
 * Живёт в ките, а не в модуле, потому что call-site'ов уже два — экран
 * «Настройки» и блок «Автоматика» в разделе «Чарджбеки», — и вторая копия
 * означала бы две разные раскладки и два разных способа связать описание с
 * тумблером для скринридера.
 */
export function SettingRow({ id, label, description, checked, disabled, onChange, className, }) {
    const helpId = `${id}-help`;
    return (_jsxs("div", { className: cn('flex items-start gap-4', className), children: [checked === null ? null : (_jsx(Switch, { id: id, checked: checked, "aria-describedby": helpId, disabled: disabled, onCheckedChange: (value) => onChange?.(value) })), _jsxs("div", { className: "flex flex-col gap-0.5", children: [_jsx(Label, { htmlFor: id, className: "leading-5 cursor-pointer text-[var(--color-text-primary)]", children: label }), _jsx("p", { id: helpId, className: "text-xs text-[var(--color-text-muted)]", children: description })] })] }));
}
//# sourceMappingURL=setting-row.js.map